import React from 'react';
import "./assets/Header.css";
import "./assets/OnboardLicense.css";

function Footer() {

    const message = `Qualcomm Confidential and Proprietary. Copyright © 2025 QUALCOMM incorporated.\nAll Rights Reserved. May contain U.S. or international export controlled information.`;

    const formattedMessage = message.split('\n').map((line, index) => (
        <React.Fragment key={index}>
          {line}
          <br />
        </React.Fragment>
      ));

    return <div className="footer">
        <div className='row-footer'>
            <div className="header-section project-name"><h3>Qualcomm</h3></div>
            <a className="contact-qsd-team" href="mailto:qsd.server.sw@qti.qualcomm.com">
                <span>Contact QSD Server Team</span>
            </a>
        </div>
        <div className='footer-detail-section'>
            <p>{formattedMessage}</p>
        </div>
    </div>;
};

export default Footer;